import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MatCheckboxModule,
  MatTabsModule,
  MatSelectModule,
} from "@angular/material";
import { MatRadioModule } from "@angular/material";
import { MatSlideToggleModule } from "@angular/material";
import { MatSliderModule } from "@angular/material";
import { MatSnackBarModule } from "@angular/material";
import { AppRoutingModule } from "./app.routing.module";

// 以下長時間追加
import { MatExpansionModule } from "@angular/material/expansion";
import { MatInputModule } from "@angular/material/input";

import { AppComponent } from "./app.component";
import { SigninComponent } from "./c9901-signin/signin.component";
import { ChangepwComponent } from "./c9901-signin/changepw.component";
import { AuthGuard } from "./service/auth.guard";
import { MessageBoxComponent } from "./c9902-messagebox/messagebox.component";

import { infoComponent } from "./c9903-info/info.component";

import { AdminComponent } from "./a0100-admin/admin.component";
import { EventComponent } from "./a0101-event/event.component";
import { AContentListComponent } from "./a0101-event/a-content-list.component";
import { QuestionCategoryComponent } from "./a0102-question-category/question-category.component";
import { QuestionListComponent } from "./a0104-question-list/question-list.component";
import { QuestionRegisterComponent } from "./a0103-question-register/question-register.component";
import { LanguageComponent } from "./a0109-language/language.component";
import { MailComponent } from "./a0106-mail/mail.component";
import { AStatusListComponent } from "./a0106-mail/a-status-list.component";
import { ACompanyListComponent } from "./a0106-mail/a-company-list.component";
import { ATemplateSaveModalComponent } from "./a0106-mail/a-template-save-modal.component";
import { AViewTextModalComponent } from "./a0106-mail/a-view-text-modal.component";
import { ProgressComponent } from "./a0107-progress/progress.component";
import { PersonComponent } from "./a0108-person/person.component";
import { AOutputModalComponent } from "./a0108-person/a-output-modal.component";
import { A0112AnswerStartPreviewComponent } from "./a0112-answer-preview/a0112-answer-start-preview.component";
import { A0112AnswerMainPreviewComponent } from "./a0112-answer-preview/a0112-answer-main-preview.component";
import { A0112ConfirmPreviewComponent } from "./a0112-answer-preview/a0112-confirm-preview.component";
import { A0114ResultAnalysisComponent } from "./a0114-result-analysis/a0114-result-analysis.component";
import { ContractCompanyComponent } from "./a0120-contract-company/contract-company.component";
import { AbrSystemComponent } from "./c9900-abr-system/abr-system.component";
import { InputHistoryComponent } from "./a0115-input-history/input-history.component";
import { OutputHistoryComponent } from "./a0119-output-history/output-history.component";
import { MailHistoryComponent } from "./a0116-mail-history/mail-history.component";
import { AccessLogComponent } from "./a0117-access-log/access-log.component";
import { AccountListComponent } from "./a0118-account-list/account-list.component";
import { ContractCompanyListComponent } from "./a0120-contract-company/contract-company-list.component";

import { AListComponent } from "./a0103-question-register/a-list.component";
import { AListModalComponent } from "./a0103-question-register/a-list-modal.component";
import { AListNextComponent } from "./a0103-question-register/a-list-next.component";
import { ASelectComponent } from "./a0103-question-register/a-select.component";

import { CommonService } from "./service/common.service";
import { MessageService } from "./service/message.service";
import { UsersService } from "./service/users.service";
import { MasterService } from "./service/master.service";
import { QuestionService } from "./service/question.service";
import { QuestionCategoryService } from "./service/questioncategory.service";
import { EventService } from "./service/event.service";
import { MonshinService } from "./service/monshin.service";
import { AnalysisService } from "./service/analysis.service";
import { MailService } from "./service/mail.service";
import { PersonService } from "./service/person.service";
import { AbrsystemService } from "./service/abrsystem.service";
import { YoyakuMasterService } from "./service/ymaster.service";
import { YoyakuService } from "./service/yoyaku.service";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ChartsModule } from "ng2-charts";

import { B0001HomeComponent } from "./b0001-home/b0001-home.component";
import { B0101AnswerComponent } from "./b0101-answer/b0101-answer.component";
import { B0102AnswerComponent } from "./b0102-answer/b0102-answer.component";
import { B0103ConfirmComponent } from "./b0103-confirm/b0103-confirm.component";
//ユーザー結果ダウンロード追加202409
import { KekkaDownloadComponent } from "./b0104-kekka-download/kekka-download.component";

//ユーザー結果アップロード追加202510
import { KekkaUploadComponent } from "./b0105-kekka-upload/kekka-upload.component";
import { UploadSettingComponent } from "./a2128-upload-setting/upload-setting.component";
import { KenshinkekkaUploadComponent } from "./b0106-kenshinkekka-upload/kenshinkekka-upload.component";
import { UploadService } from "./service/upload.service";

import { BRadioComponent } from "./parts/b-radio/b-radio.component";
import { BCheckboxComponent } from "./parts/b-checkbox/b-checkbox.component";
import { BSelectComponent } from "./parts/b-select/b-select.component";
import { BTextComponent } from "./parts/b-text/b-text.component";
import { BTextareaComponent } from "./parts/b-textarea/b-textarea.component";
import { BDateFromto1Component } from "./parts/b-datefromto1/b-datefromto1.component";
import { BLabelText1Component } from "./parts/b-labeltext1/b-labeltext1.component";
import { BNoneComponent } from "./parts/b-none/b-none.component";

import { SearchAnswerIdPipe } from "./pipes/search-answer-id.pipe";
import { ShowResultPipe } from "./pipes/show-result.pipe";
import { FilterLangIdPipe } from "./pipes/filter-langu-id.pipe";
import { FilterCompanyIdPipe } from "./pipes/filter-company-id.pipe";

import { ShareService } from "./service/share.service";
import { AdminshareService } from "./service/adminshare.service";
import { EventReplyDatePipe } from "./pipes/event-reply-date.pipe";
import { EventPublishDatePipe } from "./pipes/event-publish-date.pipe";
import { TargetQuestionPipe } from "./pipes/target-question.pipe";
import { QuestionBreakPipe } from "./pipes/question-break.pipe";
import { AGraphComponent } from "./parts/a-graph/a-graph.component";
import { QuestionBreakHtmlPipe } from "./pipes/question-break-html.pipe";
import { AnswerHiddenCheckPipe } from "./pipes/answer-hidden-check.pipe";
import { MyoyakuConditionPipe } from "./pipes/myoyaku-condition.pipe";
import { yoyakuCountDisplayPipe } from "./pipes/yoyaku-count-display.pipe";
import { SafePipe } from "./pipes/safe.pipe";

import { MaintenanceComponent } from "./a0110-maintenance/maintenance.component";
import { MCompanyComponent } from "./a0121-mcompany/mcompany.component";
import { MJigyobaComponent } from "./a0122-mjigyoba/mjigyoba.component";
import { MSyokubaComponent } from "./a0123-msyokuba/msyokuba.component";
import { MSyozokuComponent } from "./a0124-msyozoku/msyozoku.component";
import { MJigyosyoComponent } from "./a0125-mjigyosyo/mjigyosyo.component";
import { MYakusyokuComponent } from "./a0126-myakusyoku/myakusyoku.component";
import { MShikakuComponent } from "./a0127-mshikaku/mshikaku.component";
import { MSyokusyuComponent } from "./a0128-msyokusyu/msyokusyu.component";
import { MMibunComponent } from "./a0129-mmibun/mmibun.component";
import { MCourseComponent } from "./a0130-mcourse/mcourse.component";
import { OutputService } from "./service/output.service";

import { SearchAnswerModalComponent } from "./a0108-person/search-answer-modal.component"; // 追加 20191002

import { YoyakuHyoComponent } from "./a2102-yoyaku-hyo/yoyaku-hyo.component";
import { YoyakuListComponent } from "./a2104-yoyaku-list/yoyaku-list.component";
import { YoyakuRegisterComponent } from "./a2103-yoyaku-register/yoyaku-register.component";
import { YoyakuAcceptListComponent } from "./a2105-yoyaku-accept-list/yoyaku-accept-list.component";
import { YoyakuMaintenanceComponent } from "./a2120-yoyaku-maintenance/yoyaku-maintenance.component";
import { YTimeaxisListComponent } from "./a2121-ytimeaxis-list/ytimeaxis-list.component";
import { YTimeaxisComponent } from "./a2122-ytimeaxis/ytimeaxis.component";
import { AContentListTimeaxisComponent } from "./a2122-ytimeaxis/a-content-list-timeaxis.component";
import { YDivision1Component } from "./a2123-ydivision1/ydivision1.component";
import { YDivision2Component } from "./a2124-ydivision2/ydivision2.component";
import { AContentListDivision1Component } from "./a2123-ydivision1/a-content-list-division1.component";
import { AContentListDivision2Component } from "./a2124-ydivision2/a-content-list-division2.component";
import { YConditionsGroupSComponent } from "./a2125-yconditions-group-s/yconditions-group-s.component";
import { YConditionsGroupMComponent } from "./a2126-yconditions-group-m/yconditions-group-m.component";
import { YConditionsGroupLComponent } from "./a2127-yconditions-group-l/yconditions-group-l.component";
import { B0001AcceptModalComponent } from "./b0001-home/b0001-accept-modal.component";
import { AYoyakuMemoModalComponent } from "./a0108-person/a-yoyaku-memo-modal.component";

import { B0202YoyakuComponent } from "./b0202-yoyaku/b0202-yoyaku.component";
import { B0203ConfirmComponent } from "./b0203-confirm/b0203-confirm.component";
import { A2112YoyakuMainPreviewComponent } from "./a2112-yoyaku-preview/a2112-yoyaku-main-preview.component";
import { A2112ConfirmPreviewComponent } from "./a2112-yoyaku-preview/a2112-confirm-preview.component";
import { YoyakuStatusMarkIdPipe } from "./pipes/yoyaku-status-mark-id.pipe";
import { YoyakuDateFilterPipe } from "./pipes/yoyaku-date-filter.pipe";
import { YoyakuConditionsEditModalComponent } from "./a2103-yoyaku-register/yoyaku-conditions-edit.component";
import { DayoftheweekSelecterModalComponent } from "./a2103-yoyaku-register/dayoftheweek-selecter.component";
import { AutoLinkByDescriptionPipe } from "./pipes/auto-link-by-description.pipe";
import { YoyakuListViewComponent } from "./a2104-yoyaku-list/yoyaku-list-view.component";
import { SearchYoyakuDayModelComponent } from "./a0108-person/search-yoyaku-day-model.component";
import { TimeaxisSelecterComponent } from "./a2103-yoyaku-register/timeaxis-selecter.component";
import { MailTaskCreateComponent } from "./a0106-mail/a-mailtask-create.component";
import { ShowYoyakuCreateriaComponent } from "././a2103-yoyaku-register/show-yoyaku-createria.component";
import { ConditionSelecterModalComponent } from "./a2125-yconditions-group-s/condition-selecter-modal.component";
import { ConditionContentListComponent } from "./a2126-yconditions-group-m/condition-content-list.component";
import { ConditionContentListLComponent } from "./a2127-yconditions-group-l/condition-content-list-l.component";

import { YoyakuListAddComponent } from "./g3801-yoyaku-list-add/yoyaku-list-add.component";
import { YoyakuConfirmAddComponent } from "./g3802-yoyaku-confirm-add/yoyaku-confirm-add.component";

import { ATaskShowModalComponent } from "./a0106-mail/a-mailtask-show-modal.component";

import { YoyakuPropertyModelComponent } from "./a0108-person/yoyaku-property-model.component";

import { CameraComponent } from "./parts/camera/camera.component";
import { PdfUploadFormComponent } from "./parts/pdf/pdf-upload-form/pdf-upload-form.component";
import { PdfPreviewModalComponent } from "./parts/pdf/pdf-preview-modal/pdf-preview-modal.component";
import { pdfThumbnailListModalModalComponent } from "./parts/pdf/pdf-thumbnail-list-modal/pdf-thumbnail-list-modal.component";

import { PdfService } from "./service/pdf.service";
import { FileUploadService } from "./service/fileupload.service";

// 受検者一覧をコンテンツごとに分解 =========================================================================
import { PersonTableDefaultComponent } from "./a0108-person/table/default/table-default.component"; // テーブル
import { SearchFormDefaultComponent } from "./a0108-person/search-form/default/search-form-default.component"; // 検索タブ
import { PersonOperationPanelDefaultComponent } from "./a0108-person/operation-panel/default/operation-panel-default.component"; // 操作パネル
import { PersonImportManagementDefaultComponent } from "./a0108-person/import-management/default/import-management-default.component"; // 取込タブ
import { PersonOutputManagementDefaultComponent } from "./a0108-person/output-management/default/output-management-default.component"; // 出力タブ
import { PersonEditFormDefaultComponent } from "./a0108-person/edit-form/default/edit-form-default.component"; // 編集フォーム
// =======================================================================================================

// JICA カスタマイズ用受検者一覧をコンテンツごとに分解 =========================================================================
import { PersonTableJicaComponent } from "./a0108-person/table/jica/table-jica.component"; // テーブル
import { SearchFormJicaComponent } from "./a0108-person/search-form/jica/search-form-jica.component"; // 検索タブ
import { PersonOperationPanelJicaComponent } from "./a0108-person/operation-panel/jica/operation-panel-jica.component"; // 操作パネル
import { PersonImportManagementJicaSaikenComponent } from "./a0108-person/import-management/jica/saiken/import-management-jica-saiken.component"; // 操作パネル
import { PersonEditFormJicaComponent } from "./a0108-person/edit-form/jica/edit-form-jica.component"; // 編集フォーム
// =========================================================================================================================

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule.forRoot(),
    ChartsModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatTabsModule,
    MatInputModule,
    MatExpansionModule,
    MatSelectModule,
  ],
  declarations: [
    AppComponent,
    SigninComponent,
    ChangepwComponent,
    AdminComponent,
    EventComponent,
    AContentListComponent,
    QuestionCategoryComponent,
    QuestionListComponent,
    QuestionRegisterComponent,
    LanguageComponent,
    MailComponent,
    ProgressComponent,
    PersonComponent,
    AOutputModalComponent,
    ContractCompanyComponent,
    AbrSystemComponent,
    InputHistoryComponent,
    OutputHistoryComponent,
    MailHistoryComponent,
    AccessLogComponent,
    AccountListComponent,
    ContractCompanyListComponent,
    MessageBoxComponent,
    AListComponent,
    AListModalComponent,
    AListNextComponent,
    ASelectComponent,
    AStatusListComponent,
    ACompanyListComponent,
    ATemplateSaveModalComponent,
    AViewTextModalComponent,
    B0001HomeComponent,
    B0101AnswerComponent,
    B0102AnswerComponent,
    B0103ConfirmComponent,
    //ユーザー結果ダウンロード追加202409
    KekkaDownloadComponent,
    BRadioComponent,
    BCheckboxComponent,
    BSelectComponent,
    BTextComponent,
    BDateFromto1Component,
    BLabelText1Component,
    BNoneComponent,
    SearchAnswerIdPipe,
    ShowResultPipe,
    BTextareaComponent,
    FilterLangIdPipe,
    FilterCompanyIdPipe,
    EventReplyDatePipe,
    EventPublishDatePipe,
    TargetQuestionPipe,
    QuestionBreakPipe,
    SafePipe,
    A0112AnswerStartPreviewComponent,
    A0112AnswerMainPreviewComponent,
    A0112ConfirmPreviewComponent,
    A0114ResultAnalysisComponent,
    AGraphComponent,
    QuestionBreakHtmlPipe,
    AnswerHiddenCheckPipe,
    MaintenanceComponent,
    MCompanyComponent,
    MJigyobaComponent,
    MSyokubaComponent,
    MSyozokuComponent,
    MJigyosyoComponent,
    MYakusyokuComponent,
    MShikakuComponent,
    MSyokusyuComponent,
    MMibunComponent,
    MCourseComponent,
    SearchAnswerModalComponent, //追加 20191002
    YoyakuHyoComponent,
    YoyakuListComponent,
    YoyakuRegisterComponent,
    YoyakuAcceptListComponent,
    YoyakuMaintenanceComponent,
    YTimeaxisListComponent,
    YTimeaxisComponent,
    YDivision1Component,
    YDivision2Component,
    AContentListDivision1Component,
    AContentListDivision2Component,
    AContentListTimeaxisComponent,
    YConditionsGroupSComponent,
    YConditionsGroupMComponent,
    YConditionsGroupLComponent,
    B0001AcceptModalComponent,
    AYoyakuMemoModalComponent,
    B0202YoyakuComponent,
    B0203ConfirmComponent,
    A2112YoyakuMainPreviewComponent,
    A2112ConfirmPreviewComponent,
    YoyakuStatusMarkIdPipe,
    YoyakuDateFilterPipe,
    YoyakuConditionsEditModalComponent,
    DayoftheweekSelecterModalComponent,
    YoyakuListViewComponent,
    AutoLinkByDescriptionPipe,
    MyoyakuConditionPipe,
    yoyakuCountDisplayPipe,
    infoComponent,
    SearchYoyakuDayModelComponent,
    TimeaxisSelecterComponent,
    MailTaskCreateComponent,
    ShowYoyakuCreateriaComponent,
    ConditionSelecterModalComponent,
    ConditionContentListComponent,
    ConditionContentListLComponent,
    YoyakuListAddComponent,
    YoyakuConfirmAddComponent,
    ATaskShowModalComponent,
    YoyakuPropertyModelComponent,
    //ユーザー結果アップロード追加202510
    KekkaUploadComponent,
    KenshinkekkaUploadComponent,
    UploadSettingComponent,
    CameraComponent,
    PdfUploadFormComponent,
    PdfPreviewModalComponent,
    pdfThumbnailListModalModalComponent,
    PersonTableDefaultComponent,
    SearchFormDefaultComponent,
    PersonTableJicaComponent,
    SearchFormJicaComponent,
    PersonOperationPanelJicaComponent,
    PersonOperationPanelDefaultComponent,
    PersonImportManagementJicaSaikenComponent,
    PersonImportManagementDefaultComponent,
    PersonOutputManagementDefaultComponent,
    PersonEditFormJicaComponent,
    PersonEditFormDefaultComponent,
  ],
  entryComponents: [
    MessageBoxComponent,
    AListModalComponent,
    AContentListComponent,
    ATemplateSaveModalComponent,
    AViewTextModalComponent,
    AOutputModalComponent,
    SearchAnswerModalComponent, //20191002 追加
    B0001AcceptModalComponent,
    AYoyakuMemoModalComponent,
    YoyakuConditionsEditModalComponent,
    AContentListDivision1Component,
    AContentListDivision2Component,
    AContentListTimeaxisComponent,
    DayoftheweekSelecterModalComponent,
    YoyakuListViewComponent,
    SearchYoyakuDayModelComponent,
    TimeaxisSelecterComponent,
    MailTaskCreateComponent,
    ShowYoyakuCreateriaComponent,
    ConditionSelecterModalComponent,
    ConditionContentListComponent,
    ConditionContentListLComponent,
    YoyakuListAddComponent,
    ATaskShowModalComponent,
    YoyakuPropertyModelComponent,
    PdfPreviewModalComponent,
    pdfThumbnailListModalModalComponent,
  ],
  providers: [
    CommonService,
    UsersService,
    MasterService,
    MessageService,
    QuestionService,
    QuestionCategoryService,
    EventService,
    MonshinService,
    ShareService,
    AdminshareService,
    AnalysisService,
    AuthGuard,
    MailService,
    PersonService,
    AbrsystemService,
    OutputService,
    YoyakuMasterService,
    YoyakuService,
    PdfService,
    FileUploadService,
    UploadService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts